import './descriptionGovIncentive.scss';


import React from 'react';
import iconIncentive from '../../images/icons/gov-incentives-bleu.png';
import { useTranslation } from 'react-i18next';
import { LocalizedLink } from '../primitives';

export default function DescriptionGovIncentive() {
    const { t } = useTranslation('templatePages');

    return (
        <div className='gov-credit'>
            <div className='gov-credit-icon'>
                <img src={iconIncentive} alt='icon-gov-incentive' />
            </div>

            <div>
                <div className='gov-text-title'>{t('title-gov-inc')}</div>
                <span className='gov-text'>{t('text-gov-inc')}</span>

                <LocalizedLink to='/government-incentives/'>
                    <span className='gov-text-click hover-underline-to-none'>
                        {t('link-gov-inc')}
                    </span>
                </LocalizedLink>
            </div>
        </div>
    );
}
